//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext,useEffect, useState} from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box, Chip } from '@mui/material';

// === HOOKS ===
import { useTaskComplete } from 'components/useTaskComplete';
import { useTaskStatus } from 'components/hooks/useTaskStatus/index';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function InfoChips() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const {task_id, has_task} = useTaskStatus();

  const monitoring  = '';
  const mode        = '';

  const completion_status = useTaskComplete();

  const [ task_name   , setTaskName   ] = useState( '' );
  const [ process     , setProcess    ] = useState( '' );
  const [ tenant      , setTenant     ] = useState( '' );
  const [ prokey_mode , setProkeyMode ] = useState( '' );

  const field_progress_text = `${completion_status.accepted} / ${completion_status.total}`;

  const task_status_text     = monitoring ? 'Processing Tasks' : 'Processing Paused';
  const correction_mode_text = mode === 'CORRECT_ALL' ? 'View All Fields' : 'View Uncertain Fields';

  const _styles = {
    container: {
      display        : 'flex'   ,
      justifyContent : 'center' ,
      aligntItems    : 'center' ,
      // flex          : '0 0 auto'       ,
      // flexDirection : 'column'         ,
      // flexWrap      : 'wrap'           ,
    },
    sub_container: {
      display       : 'flex'           ,
      flexDirection : 'column'         ,
    },
    task_status: {
      display        : task_status_text ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    correction_mode: {
      display        : correction_mode_text ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    prokey_mode: {
      display        : prokey_mode ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    field_progress: {
      display        : field_progress_text ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    task_id: {
      display        : task_id ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    task_name: {
      display        : task_name ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    process: {
      display        : process ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
    tenant: {
      display        : tenant ? '' : 'none',
      flex           : '1 1 fit-content' ,
      margin         : '2px'             ,
      justifyContent : 'left'            , 
    },
  }

  //#endregion

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTask(data) {
      //-----------------------------------------------------------------
      setTaskName   ( data.id      );
      setProcess    ( data.process );
      setTenant     ( data.tenant  );
      setProkeyMode ( data.mode    );
    } 
    
    on( 'TASK_INFO', handleTask );

    return () => {
      removeListener( 'TASK_INFO', handleTask );
    };
  }, [] ); 

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( !has_task ) return null;
    return (
      <Box sx={_styles.container} >        
        <Box sx={_styles.sub_container} >
          
        </Box>
        <Chip sx={ _styles.field_progress } label={ field_progress_text  } />
        <Chip sx={ _styles.task_name      } label={ task_name            } />
        <Chip sx={ _styles.process        } label={ process              } />
        <Chip sx={ _styles.tenant         } label={ tenant               } />
        <Chip sx={ _styles.prokey_mode    } label={ prokey_mode          } />
      </Box>
    );
  };

  //#endregion

  return display();
}
